module.exports = __webpack_public_path__ + "dc3e4d2c05db9137f36507323c6b111e.svg";